import { typePrice } from "./price"
import { queryCustomerSkuPrice } from "./queries/queryCustomerSkuPrice"
import { queryCustomerSkuPrices } from "./queries/queryCustomerSkuPrices"
import { querySkuListPrices } from "./queries/querySkuListPrices"

const priceSchema = {
  types: [typePrice],
  resolvers: {
    Query: { ...queryCustomerSkuPrices, ...querySkuListPrices, ...queryCustomerSkuPrice },
    Mutation: {},
  },
}

export default priceSchema
